/*
 * Copyright (c) 2010, 2023 BSI Business Systems Integration AG
 *
 * This program and the accompanying materials are made
 * available under the terms of the Eclipse Public License 2.0
 * which is available at https://www.eclipse.org/legal/epl-2.0/
 *
 * SPDX-License-Identifier: EPL-2.0
 */
import {graphics, OutlineLayout, SearchOutline} from '../../index';

export class SearchOutlineLayout extends OutlineLayout {
  declare outline: SearchOutline;

  constructor(outline: SearchOutline) {
    super(outline);
  }

  protected override _setDataHeight(heightOffset: number) {
    // Add search panel height to heightOffset
    let searchPanelSize = graphics.size(this.outline.$searchPanel, true);
    heightOffset += searchPanelSize.height;

    super._setDataHeight(heightOffset);
  }
}
